export default __webpack_public_path__ + "assets/images/8ba743c645bb659e59987380c0f00fe7.svg";